module.exports = __webpack_public_path__ + "24d42ccfe5291435906cabb1e082b698.png";


//////////////////
// WEBPACK FOOTER
// ./Res/img/title_pencil.png
// module id = 407
// module chunks = 1